import React from 'react'

const UploadProductImageModal = () => {
  return (
    <>
     <div class="modal fade" id="uploadProductImageModal" tabindex="-1" role="dialog"
                    aria-labelledby="uploadProductImageModalTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Upload Image</h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-6">

                                        <div>
                                            <div class="row bg-grey-box mt-3">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-12"  >
                                                            <div class="input-group text-align"  >
                                                                <input type="text" class="form-control lit-grey-color border-none"
                                                                    placeholder="Search a product code" />
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-secondary lit-grey-color" type="button" >
                                                                        <i class="fa fa-search" ></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-3">
                                                        <div class="col-md-3 mb-3">
                                                            <div class="library-images">
                                                                <img src="related_image.imageUrl"
                                                                    alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="no-image-found">
                                                            <i class="far fa-images"></i>
                                                            <p>No image found</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* <!-- <div class="row mt-3 mob-p-l-r">
                  <div class="col-md-3">
                    <div class="product-image mob-p-b-10">
                      <img src="related_image.imageUrl" alt="" height="46">
                    </div>
                  </div>
                </div> -->


              <!-- <div class="col-md-12">
                    <div class="row bg-grey-box">
                      <div class="col-md-4">
                        <div class="library-images">
                          <img src="related_image.imageUrl" alt=""
                            height="46">
                        </div>
                      </div>
                    </div>
                  </div> --> */}
                                        </div>
                                        <div>
                                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Upload</a>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Library</a>
                                                </li>
                                            </ul>
                                            <div class="tab-content" id="pills-tabContent">
                                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">...</div>
                                                <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">...</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="tabbable-panel">
                                            <div class="tabbable-line">
                                                <div class="tab-content mt-2">
                                                    <div class="tab-pane active" id="tab_default_1">

                                                        <div>
                                                            <label class="mt-1">Title</label>
                                                            <input type="text" class="form-control" placeholder="Title" />

                                                        </div>
                                                        <div>
                                                            <label>Model Number</label>
                                                            <input type="text" class="form-control" placeholder="Model Number" />
                                                        </div>

                                                        <div>
                                                            <label class="mt-1">File URL </label>
                                                            <input type="text" class="form-control" placeholder="Enter title" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="float-right mt-5">
                                            <button type="button" class="btn btn-link cancel-btn" data-dismiss="modal">Cancel</button>
                                            <button type="button" class="btn btn-primary black-color-bg" data-dismiss="modal">Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </>
  )
}

export default UploadProductImageModal